if (!customElements.get('related-collections-slider')) {
  class RelatedCollectionsSlider extends HTMLElement {
    slider = {};
    selectors = {
      swiper: '.swiper',
      progressbarFill: '.progress-bar__fill'
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = new Swiper(this.querySelector(this.selectors.swiper), {
        slidesPerView: 4.2,
        spaceBetween: 2,
        loop: false,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 6,
            spaceBetween: 4,
          },
          1024: {
            slidesPerView: 8
          },
        },
        on: {
          init: (swiper) => {
            this.updateProgressbar(swiper);
            this.updateSlideCounter(swiper);
          },
          slideChange: (swiper) => {
            this.updateProgressbar(swiper);
            this.updateSlideCounter(swiper);
          },
          lock: (swiper) => {
            this.querySelector('.swiper').classList.add('swiper-locked');
          },
          unlock: (swiper) => {
            this.querySelector('.swiper').classList.remove('swiper-locked');
          },
        },
      });
    }

    updateProgressbar(swiperInstance) {
      const totalSlides = swiperInstance.slides.length;
      const currentIndex = swiperInstance.realIndex + 1; // +1 because realIndex is 0-based
      const progress = (currentIndex / totalSlides) * 100;
      this.querySelector(this.selectors.progressbarFill).style.width = progress + '%';
    }

    updateSlideCounter(swiperInstance) {
      const currentIndex = swiperInstance.realIndex + 1;
      this.querySelector('.slide-counter__current').textContent = currentIndex;
    }
  }
  customElements.define('related-collections-slider', RelatedCollectionsSlider);
}
